module.exports = __webpack_public_path__ + "static/media/orga3.436152cc.svg";